// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"407":"panel","441":"superadmin","884":"admin","974":"senat-admin"}[chunkId] + "." + {"407":"76f47a37","441":"75125316","884":"fab14ce9","974":"97ce8abe"}[chunkId] + ".css";
};